import React from 'react';
import { useHistory } from 'react-router-dom';

const ProductLink = ({ ProductId, text }) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/dashboard/products/main/productdetail/${ProductId}`);
  };

  return (
    <a onClick={handleClick} className='gx-link'>
      {text}
    </a>
  );
};

export default ProductLink;
